<template>
  <v-flex xs12>
    <pdf v-for="i in numPages" :key="i" :src="pdfdata" :page="i"
      :scale.sync="scale" style="width:100%;margin:20px auto;">
      <template slot="loading">
        loading content here...
      </template>
  </pdf>
  </v-flex>
</template>

<script>
import pdf from 'pdfvuer'
import axios from 'axios'

export default {
  components: {
    pdf
  },
  data () {
    return {
      pdfdata: undefined,
      numPages: 0,
      scale: 'page-width'
    }
  },
  created () {
    axios({
      url: '/api/teammeetings/' + this.$route.params.id,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      var blob = new Blob([response.data], {type: 'application/pdf'})
      var blobURL = window.URL.createObjectURL(blob)
      this.pdfdata = pdf.createLoadingTask(blobURL)
      this.pdfdata.then(pdf => {
        this.numPages = pdf.numPages
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Teammeetings/Show.vue